import React from 'react';
import { Box, LinearProgress, Typography, Paper } from '@mui/material';

interface QuizProgressBarProps {
  current: number;
  total: number;
}

const QuizProgressBar: React.FC<QuizProgressBarProps> = ({ current, total }) => {
  const progress = total > 0 ? (current / total) * 100 : 0;

  return (
    <Paper elevation={2} sx={{ p: 2, borderRadius: 2 }}>
      <Box sx={{ mb: 1 }}>
        <Typography variant="body1" fontWeight="bold" color="text.primary">
          Question {current} of {total}
        </Typography>
      </Box>
      <LinearProgress
        variant="determinate"
        value={progress}
        sx={{
          height: 10,
          borderRadius: 5,
          bgcolor: 'grey.300',
          '& .MuiLinearProgress-bar': {
            borderRadius: 5,
            bgcolor: 'primary.main',
          },
        }}
      />
    </Paper>
  );
};

export default QuizProgressBar;
